/* Tysk katalog for locale-settings-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'set.acc.assetAutomaticPostingExplanation': 'Abschreibungen werden für jeden abgeschlossenen Monat automatisch gebucht. Plumme holt fehlende Monate nach, ohne dass du etwas tun musst.',
  'set.acc.paymentDays': 'Standard-Zahlungsfrist (Tage)',
  'set.acc.paymentDaysHelp': 'Das Fälligkeitsdatum ergibt sich aus Rechnungsdatum plus dieser Frist. Du kannst das Fälligkeitsdatum auf jeder einzelnen Rechnung überschreiben.',
  'set.acc.paymentDaysInvalid': 'Wähle eine Zahlungsfrist von 0 bis 365 ganzen Tagen.',
  'set.acc.foreignCurrencyInvoices': 'Rechnungen in Fremdwährung',
  'set.acc.foreignCurrencyInvoicesHelp': 'Zeigt Dokumentwährung und Kursfelder unter „Neuer Verkauf“ an. Lass dies deaktiviert, wenn du nur in der Buchhaltungswährung abrechnest.',
  'set.acc.advancedVatDeduction': 'Erweiterter Vorsteuerabzug auf Einkaufszeilen',
  'set.acc.advancedVatDeductionHelp': 'Zeigt Optionen für vollen oder teilweisen Abzug, wenn das Dokument MwSt. enthält. Normal sind 100 %, und bestehende Abweichungen werden immer angezeigt.',
  'set.acc.openingAssets': 'Anlagegüter in der Eröffnungsbilanz',
  'set.acc.openingAssetsHelp': 'Erfasse die Details von Vermögenswerten, die bereits in der Eröffnungsbilanz enthalten sind. Die Beträge werden mit der Eröffnungsbilanz abgestimmt, die Vermögenswerte werden aber im Anlagenverzeichnis geführt.',
  'set.acc.openingAssetsAction': 'Bestehendes Anlagegut erfassen',
  'set.acc.assetAutomation': 'Automatische monatliche Buchung von Abschreibungen',
  'set.acc.assetAutomationHelp': 'Prüfe Betrag und Zeitraum, bevor du bestätigst. Die Aktivierung bucht ausstehende abgeschlossene Monate und genehmigt die weitere Automatik. Pausieren entfernt keine gebuchten Belege.',
  'set.acc.assetAutomationActive': 'Aktiv für das gewählte Geschäftsjahr.',
  'set.acc.assetAutomationOff': 'Deaktiviert für das gewählte Geschäftsjahr.',
  'set.acc.assetAutomationReview': 'Pausiert. Prüfe und genehmige die aktualisierte Anlagengrundlage, bevor weiter automatisch gebucht wird.',
  'set.acc.assetAutomationEnableNote': 'Automatische monatliche Buchung der handelsrechtlichen Abschreibungen genehmigt.',
  'set.acc.assetAutomationDisableNote': 'Automatische monatliche Buchung vom Benutzer gestoppt.',
  'set.bank.activeFromHelp': 'Die Nachverfolgung erwartet nur Kontoauszüge ab diesem Datum.',
  'set.bank.noReconciliationHelp': 'Ohne Bankabstimmung musst du selbst prüfen, dass alle Bankbewegungen genau einmal gebucht sind, dass der Banksaldo mit der Buchhaltung übereinstimmt und dass private und geschäftliche Zahlungen nicht vermischt werden.',
  'set.bank.newAccount': 'Neues Bankkonto',
  'set.bank.invoiceDeleteBlocked': 'Das Rechnungskonto kann erst gelöscht werden, wenn ein anderes Konto gewählt ist',
  'set.bank.deleteOrDisable': 'Konto löschen oder deaktivieren',
  'set.bank.openingBalanceHelp': 'Der Banksaldo am Ende des letzten bereits abgestimmten Datums. Er dient als Kontrollanker für die Bankabstimmung, bucht aber keine Eröffnungsbilanz; den AB erfasst du unter Buchhaltung mit einem Gegenkonto.',
  'set.bank.openingBalanceDateHelp': 'Plumme beginnt die Bankabstimmung am Tag nach diesem Datum.',
  'set.bank.setupValidation.date': "Wählen Sie ein gültiges Datum.",
  'set.bank.setupValidation.year': "Das Datum muss im Geschäftsjahr {year} liegen. Wechseln Sie für einen anderen Beginn das Geschäftsjahr.",
  'set.bank.setupValidation.amount': "Geben Sie den belegten Banksaldo ein. Bei leerem Konto geben Sie 0 ein.",
  'set.bank.setupValidation.counter': "Wählen Sie das Gegenkonto aus der belegten Eröffnungsbilanz.",
  'set.bank.setupTitle': 'Startsaldo einrichten',
  'set.bank.setupIntro': 'Erfasse den belegten Banksaldo und die ausgeglichene Buchung in einem Ablauf. Plumme rät das Gegenkonto nie.',
  'set.bank.setupYearStart': 'Start zu einem neuen Geschäftsjahr',
  'set.bank.setupYearStartHelp': 'Verwende den Saldo am Ende des Vorjahres als AB der Bank im neuen Jahr.',
  'set.bank.setupMidYear': 'Mitten im Jahr zu Plumme wechseln',
  'set.bank.setupMidYearHelp': 'Verwende den Saldo am Tag, bevor Plumme die Buchhaltung übernimmt.',
  'set.bank.setupNewAccount': 'Neues Bankkonto in einer laufenden Buchhaltung',
  'set.bank.setupNewAccountHelp': 'Eine Überweisung auf ein neues Konto ist eine normale Transaktion, keine Eröffnungsbilanz.',
  'set.bank.setupUnsupported': 'Ein kombinierter Bank- und Buchhaltungs-Startsaldo wird derzeit nur für norwegische NOK-Konten unterstützt. Verwende für dieses Konto die getrennten Buchhaltungs- und Bankabläufe.',
  'set.bank.setupNewAccountTitle': 'Die tatsächliche Überweisung buchen',
  'set.bank.setupNewAccountBody': 'Erstelle oder importiere die Transaktion, mit der das Geld auf das Konto überwiesen wurde. Sobald das Hauptbuch mit der Bank übereinstimmt, kann die Bankabstimmung ohne neue Eröffnungsbilanz beginnen.',
  'set.bank.setupTransitionDate': 'Erster Tag in Plumme',
  'set.bank.setupTransitionYearHint': "Erster Tag des gew\u00e4hlten Gesch\u00e4ftsjahres. ({year})",
  'set.bank.setupTransitionMidYearHint': 'Das Datum, an dem Plumme vom bisherigen System übernimmt.',
  'set.bank.setupEvidenceDate': 'Banksaldo zum',
  'set.bank.setupEvidenceDateHint': 'Wird als Tag vor der Übernahme durch Plumme berechnet.',
  'set.bank.setupBankBalance': 'Belegter Banksaldo',
  'set.bank.setupBankBalanceHint': 'Verwende den Saldo aus dem Kontoauszug zum Stichtag.',
  'set.bank.setupLedgerAccount': 'Bankkonto im Hauptbuch',
  'set.bank.setupCounterAccount': 'Gegenkonto in der Eröffnungsbilanz',
  'set.bank.setupCounterHelp': 'Wähle, woher der Bankbetrag stammt. Das lässt sich nicht allein aus dem Banksaldo bestimmen.',
  'set.bank.setupChooseCounter': 'Gegenkonto wählen',
  'set.bank.setupNoCounter': 'Bei Nullsaldo ist kein Gegenkonto nötig',
  'set.bank.setupNoCounterMatches': 'Keine Bilanzkonten entsprechen der Suche.',
  'set.bank.setupManagedInBank': 'Mit dem Startsaldo unter Einstellungen - Bank verknüpft',
  'set.bank.setupMidYearWarning': 'Der Banksaldo ist nur ein Teil des Übergangs. Erfasse oder importiere unter Buchhaltung auch die übrigen Bilanz-, Ergebnis- und MwSt.-Zahlen aus dem bisherigen System.',
  'set.bank.setupPreview': 'Dies wird zusammen gespeichert',
  'set.bank.setupPreviewText': 'Bankbeleg: {amount} zum Stichtag. Buchhaltungs-AB: {bank} gegen {counter}.',
  'set.bank.setupNotChosen': 'Gegenkonto nicht gewählt',
  'set.bank.setupSave': 'Startsaldo und AB speichern',
  'set.bank.setupSaveError': 'Der Startsaldo konnte nicht gespeichert werden.',
  'set.bank.setupPostingNote': 'Startsaldo der Bank – {account}',
  'set.bank.setupButton': 'Startsaldo einrichten oder korrigieren',
  'set.bank.setupSummaryTitle': 'Banksaldo zum Start',
  'set.bank.setupSummaryEmpty': 'Startsaldo und Buchhaltungs-AB sind nicht eingerichtet.',
  'set.bank.setupSummaryValue': '{amount} zum {date}',
  'set.bank.setupSaved': 'Startsaldo und Eröffnungsbilanz sind gespeichert',
  'set.bank.setupSaveAccountFirst': 'Speichere zuerst das Bankkonto. Danach können Startsaldo und Eröffnungsbilanz gemeinsam eingerichtet werden.',
  'set.bank.iban': 'IBAN',
  'set.bank.bic': 'BIC',
  'set.bank.showIbanBicOnInvoice': 'IBAN und BIC auf der Rechnung anzeigen',
  'set.role.owner': 'Eigentümer',
  'set.access.noOrgNumber': 'Ohne Org.-Nr.',
  'set.access.onboardingUnavailable': 'Das Onboarding ist nicht geladen.',
  'set.access.members': 'Mitglieder',
  'set.access.membersSub': 'Eigentümer und Administratoren können aktive Zugriffe entfernen. Das Eigentum muss übertragen werden, bevor der eigene Zugriff des Eigentümers entfernt werden kann.',
  'set.access.membersOnlyAdmin': 'Nur Eigentümer und Administratoren können Mitglieder verwalten.',
  'set.access.selfRemoveHelp': 'Du kannst deinen eigenen Zugriff trotzdem entfernen, wenn du nicht Eigentümer bist.',
  'set.access.you': 'du',
  'set.access.remove': 'Entfernen',
  'set.access.membersEmpty': 'Aktive Mitglieder werden Eigentümer und Administratoren angezeigt.',
  'set.access.removeSelf': 'Meinen Zugriff entfernen',
  'set.access.transferTitle': 'Eigentum übertragen',
  'set.access.transferSub': 'Sende eine kontrollierte Einladung an den neuen Eigentümer. Das Eigentum geht erst über, wenn der Empfänger sich anmeldet und annimmt.',
  'set.access.transferOnlyOwner': 'Nur der Eigentümer kann das Eigentum übertragen.',
  'set.access.transferAdminHelp': 'Administratoren können Partner einladen, aber den Eigentümer nicht wechseln.',
  'set.access.newOwnerEmail': 'E-Mail des neuen Eigentümers',
  'set.access.afterTransferRole': 'Dein Zugriff nach der Übertragung',
  'set.access.roleAdministrator': 'Administrator',
  'set.access.transferReason': 'Grund / Notiz für das Audit',
  'set.access.transferReasonPlaceholder': 'Z. B. Unternehmen verkauft oder für einen Mandanten angelegt',
  'set.access.sendTransfer': 'Inhaberwechsel senden',
  'set.access.ownershipTransfer': 'Inhaberwechsel',
  'set.access.expired': 'Abgelaufen',
  'set.access.viewAccept': 'Ansehen und annehmen',
  'set.access.unknown': 'unbekannt',
  'set.access.resend': 'Erneut senden',
  'set.tab.accounting': 'Buchhaltung',
  'set.tab.data': 'Daten',
  'set.companyEmailHint': 'Wird aus deiner Anmeldung übernommen.',
  'set.countryLocked': 'Das Land wird beim Anlegen des Unternehmens gewählt und kann hier nicht geändert werden. Wende dich bei Fehlern an den Support.',
  'set.inboxUpdatedAt': 'Zuletzt aktualisiert {date}',
  'set.inboxCopied': 'E-Mail kopiert',
  'set.profileEmailHint': 'Die E-Mail-Adresse wird hier nicht geändert, da Firebase eine erneute Anmeldung verlangen kann.',
  'set.subscriptionPlan': 'Tarif: {plan}',
  'set.subscriptionInactive': 'Abonnement nicht aktiviert',
  'set.subscriptionTrialUntil': 'Testphase bis {date}',
  'set.subscriptionChooseHelp': 'Wähle einen Tarif, um den Checkout in Stripe zu starten.',
  'set.subscriptionDisconnected': 'Nicht verbunden',
  'set.subscriptionCurrentPlan': 'Aktueller Tarif',
  'set.subscriptionChoosePlan': '{name} wählen',
  'set.subscriptionFeature.bookkeeping': 'Buchhaltung',
  'set.subscriptionFeature.invoiceEmailEhf': 'Rechnung per E-Mail und EHF',
  'set.subscriptionFeature.publicFiling': 'Einreichung bei den Behörden',
  'set.subscriptionFeature.invoiceEmail': 'Rechnung per E-Mail',
  'set.subscriptionFeature.taxFigures': 'Zahlen für MwSt. und Steuererklärung',
  'set.subscriptionFeature.taxIntegration': 'Integration mit Skatteetaten',
  'set.acc.setupTab': 'Einrichtung',
  'set.acc.chartTab': 'Kontenplan',
  'set.acc.vatPeriodAnnual': 'Jährlich',
  'set.acc.vatPeriodBimonthly': 'Alle zwei Monate',
  'set.acc.vatPeriodMonthly': 'Monatlich',
  'set.acc.vatPeriodQuarterly': 'Vierteljährlich',
  'set.acc.vatPeriod.monthly': 'Monatlich',
  'set.acc.vatPeriod.bimonthly': 'Alle zwei Monate',
  'set.acc.vatPeriod.quarterly': 'Vierteljährlich',
  'set.acc.vatPeriod.semiannual': 'Halbjährlich',
  'set.acc.vatPeriod.annual': 'Jährlich',
  'set.acc.vatPeriodEffectiveYear': 'Gilt ab Jahr',
  'set.acc.vatPeriodEffectiveYearHelp': 'Gib das Jahr an, das im Bescheid von Skatteetaten steht. Die Änderung gilt ab dem 1. Januar dieses Jahres. Ein abgeschlossenes Jahr muss wieder geöffnet werden, und abgegebene MVA-meldinger müssen zuerst geöffnet oder storniert werden.',
  'set.acc.vatPeriodEffectiveYearInvalid': 'Gib ein gültiges vierstelliges Jahr an.',
  'set.acc.vatPeriodHistory': 'Verlauf des MwSt.-Zeitraums',
  'set.acc.vatPeriodConfirmTitle': 'Möchtest du den MwSt.-Zeitraum wirklich ändern?',
  'set.acc.vatPeriodConfirmText': 'Die Änderung gilt ab dem 1. Januar {year}. Prüfe, ob das Jahr mit dem Bescheid von Skatteetaten übereinstimmt. Frühere Jahre bleiben unverändert. Ein abgeschlossenes Jahr muss wieder geöffnet werden, und abgegebene MVA-meldinger müssen zuerst geöffnet oder storniert werden.',
  'set.acc.vatPeriodConfirm': 'Änderung bestätigen',
  'set.acc.notVatRegisteredNotice': 'Ist das Unternehmen nicht für die MwSt. registriert, werden neue Rechnungen auf 0 % MwSt. gesetzt. Einkäufe können weiterhin mit MwSt. auf dem Beleg erfasst werden, jedoch ohne Vorsteuerabzug.',
  'set.acc.midYearText': 'Verwende dies, wenn du mitten im Jahr zu Plumme wechselst und die Berichte mit Zahlen aus dem bisherigen System fortgeführt werden sollen.',
  'set.acc.openingSaved': 'Startzahlen gespeichert',
  'set.acc.openingSavedFrom': 'Startzahlen ab {date} gespeichert.',
  'set.acc.openingBalanceText': 'Verwende dies, wenn du mit einem neuen Geschäftsjahr beginnst und die Eröffnungsbilanzwerte aus dem Vorjahr eingeben möchtest.',
  'set.startup.linkedBalanceTitle': 'Eröffnungsbilanz inbegriffen',
  'set.startup.linkedBalanceHelp': 'Das sind dieselben Bilanzzeilen wie im Assistenten für die Eröffnungsbilanz. Bankzeilen werden unter Einstellungen - Bank korrigiert.',
  'set.acc.balanceBooked': 'Gebucht {date} - {count} {lines}',
  'set.acc.line': 'Zeile',
  'set.acc.lines': 'Zeilen',
  'set.acc.enterAccountNumber': 'Kontonummer eingeben',
  'set.acc.equivalentHint': 'Steuert die Behandlung im Jahresabschluss und in der Steuererklärung.',
  'set.acc.saveChart': 'Kontenplan speichern',
  'set.acc.equivalentShort': 'Entspricht',
  'set.acc.usedInHistory': 'In der Historie verwendet',
  'set.acc.activate': 'Aktivieren',
  'set.acc.editAccount': 'Konto bearbeiten',
  'set.acc.deactivateUsed': 'Verwendetes Konto deaktivieren',
  'set.acc.deleteUnused': 'Unbenutztes Konto löschen',
  'set.ib.intro': 'Hier gibst du die Eröffnungsbilanzwerte aus dem vorigen Geschäftsjahr ein. Verwende dies, wenn du mit einem neuen Jahr beginnst und die Bilanz in Plumme vom ersten Tag an stimmen soll.',
  'set.ib.attachment': 'Anhang',
  'set.ib.uploadDocuments': 'Dokumente hochladen',
  'set.ib.uploading': 'Wird hochgeladen...',
  'set.ib.created': 'Erstellt',
  'set.ib.uploadReceipt': 'Neuen Beleg hochladen',
  'set.ib.emptyHelp': 'Du musst mindestens eine Zeile hinzufügen, bevor du die Eröffnungsbilanz erstellen kannst. Verwende die Schaltfläche „Neue Zeile hinzufügen“, um die Zahlen aus dem bisherigen System einzugeben.',
  'set.ib.postHelp': 'Bestätige, dass die Eröffnungsbilanz korrekt und buchungsbereit ist. Du kannst sie danach weiterhin ändern, solange der Zeitraum offen ist.',
  'set.ib.draftFor': 'Entwurf der Eröffnungsbilanz für {date}',
  'set.ib.createdAt': 'Erstellt {date}',
  'set.ib.balanceHelp': 'Gib den Saldo jedes Kontos aus dem abgeschlossenen Abschluss ein. Die gesamte Eröffnungsbilanz muss gleich hohe Soll- und Habensummen haben.',
  'set.ib.noteOptional': 'Anmerkung (optional)',
  'set.ib.difference': 'Differenz',
  'set.ib.saveDraft': 'Entwurf speichern',
  'set.ib.validationHelp': 'Prüfe, dass jede Zeile ein Konto und einen positiven Betrag auf genau einer Seite hat und dass die Sollsumme der Habensumme entspricht.',
  'set.ib.excludedRows': '{count} Erfolgs- oder unbekannte Konten werden aus der ordentlichen Eröffnungsbilanz herausgehalten. Prüfe sie in der Importgrundlage.',
  'set.transitionImport.confirmSigned': 'Spalte und Vorzeichen vor dem Import bestätigen',
  'set.transitionImport.balanceColumn': 'Saldospalte',
  'set.transitionImport.signConvention': 'Vorzeichenkonvention',
  'set.transitionImport.positiveDebit': 'Positiv ist Soll, negativ ist Haben',
  'set.transitionImport.positiveCredit': 'Positiv ist Haben, negativ ist Soll',
  'set.transitionImport.signExample': 'Beispiel: Mit „Positiv ist Soll“ wird −427 473,92 zu Haben 427 473,92.',
  'set.transitionImport.confirmImport': 'Bestätigen und Vorschau',
  'set.transitionImport.helpImage': 'SAF-T, Excel, CSV oder Bild. Hineinziehen oder mit Ctrl+V einfügen.',
  'sd.deleteAllTitle': 'Alle {label} löschen',
  'sd.deleteAllMessage': 'Alle {label} ({count}) löschen? Historische Rechnungen und Belege bleiben erhalten, aber das Register wird geleert. Dies kann nicht rückgängig gemacht werden. Wir empfehlen, zuerst einen Export zu erstellen.',
  'sd.label.customers': 'Kunden',
  'sd.label.suppliers': 'Lieferanten',
  'sd.label.products': 'Produkte',
  'sd.importing': 'Import läuft...',
  'sd.documentReferenceMissing': 'Dem Dokument fehlt die Referenz auf das Importpaket.',
  'sd.documentLinkFailed': 'Der Dokumentlink konnte nicht abgerufen werden.',
  'sd.documentOpenFailed': 'Das importierte Dokument konnte nicht geöffnet werden.',
  'sd.kind.voucher': 'Belege',
  'sd.kind.inbox': 'Posteingang',
  'sd.kind.bankReconciliation': 'Bankabstimmungen',
  'sd.kind.company': 'Unternehmensdokumente',
  'sd.kind.invoice': 'Rechnung',
  'sd.kind.quote': 'Angebot',
  'sd.kind.creditNote': 'Gutschrift',
  'sd.kind.orderConfirmation': 'Auftragsbestätigung',
  'sd.kind.paymentReminder': 'Zahlungserinnerung',
  'sd.kind.otherCount': 'Andere {count}',
  'sd.kind.allCount': 'Alle {count}',
  'sd.reportCsv': 'Bericht CSV',
  'sd.reportXlsx': 'Bericht XLSX',
  'sd.openItems.exported': '{count} offene Posten exportiert',
  'sd.openItems.exportFailed': 'Der Bericht konnte nicht exportiert werden.',
  'sd.openItems.title': 'Importierte offene Posten prüfen',
  'sd.openItems.count': 'offene Posten',
  'sd.openItems.remainingTotal': 'Summe Restbetrag',
  'sd.openItems.possibleDeviations': 'mögliche Abweichungen',
  'sd.openItems.search': 'Nach Name, Rechnungsnr., Datum oder Blatt suchen',
  'sd.filter.all': 'Alle',
  'sd.filter.customers': 'Kunden',
  'sd.filter.suppliers': 'Lieferanten',
  'sd.openItems.checkDeviation': 'Abweichungen gegenüber dem Nebenbuchsaldo prüfen',
  'sd.openItems.deviation': '{label}: {party} weicht um {amount} ab',
  'sd.unnamed': 'Ohne Namen',
  'sd.openItems.rowMeta': '#{invoice} · Datum {date} · fällig {due}',
  'sd.openItems.empty': 'Keine offenen Importposten entsprechen dem Filter.',
  'sd.documents.title': 'Importiertes Dokumentenarchiv',
  'sd.documents.count': 'Dokumente',
  'sd.documents.types': 'Typen',
  'sd.documents.packages': 'Exportpakete',
  'sd.documents.search': 'Nach Datei, Jahr, Belegnr. oder internem Pfad suchen',
  'sd.documents.sortType': 'Sortieren: Typ',
  'sd.documents.sortYear': 'Sortieren: Jahr',
  'sd.documents.sortName': 'Sortieren: Dateiname',
  'sd.documents.basis': 'Archivgrundlage',
  'sd.documents.basisHelp': 'Die Dokumente sind als Importindex zum ursprünglichen Exportpaket gespeichert. Sie erstellen nicht automatisch Rechnungen, Einkäufe, Belege oder Posteingangselemente.',
  'sd.documents.fallback': 'Dokument',
  'sd.documents.unknownPath': 'Unbekannter Pfad im Exportpaket',
  'sd.documents.fetching': 'Wird geladen...',
  'sd.documents.open': 'Öffnen',
  'sd.documents.empty': 'Keine importierten Dokumente entsprechen dem Filter.',
  'sd.ledger.title': 'Importiertes Hauptbucharchiv',
  'sd.ledger.linesShown': 'Verlaufszeilen im angezeigten Archiv',
  'sd.ledger.debitShown': 'Soll in der angezeigten Auswahl',
  'sd.ledger.creditShown': 'Haben in der angezeigten Auswahl',
  'sd.ledger.search': 'Nach Beleg, Konto, Text, Datum oder Quelle suchen',
  'sd.ledger.allYears': 'Alle Jahre',
  'sd.ledger.historyOnly': 'Nur Verlauf',
  'sd.ledger.historyHelp': 'Die Zeilen hier sind ein lesbares Importarchiv aus dem früheren System. Die Summen oben sind Soll/Haben der angezeigten Archivauswahl, nicht Umsatz. Die Zeilen fließen nicht in Plumme-Berichte, MwSt., Steuern, Bankabstimmung oder die aktuelle Belegliste ein.',
  'sd.ledger.noText': 'Kein Text',
  'sd.ledger.linkedCount': 'Verknüpfte Belege im Dokumentarchiv: {count}',
  'sd.ledger.empty': 'Keine importierten Hauptbuchzeilen entsprechen dem Filter.',
  'sd.ledger.linkedTitle': 'Verknüpfte Belege',
  'sd.ledger.archiveDocument': 'Archivdokument',
  'sd.ledger.archiveDocumentHelp': 'Dies sind Dokumentverweise aus dem ursprünglichen Exportpaket. Sie erzeugen keine aktuellen Belege oder Posteingangselemente.',
  'sd.ledger.noDocumentDetails': 'Für diese Zeile sind keine Dokumentdetails gespeichert.',
  'sd.ledger.showing': '{shown} von {total} Treffern für diese Verlaufszeile werden angezeigt.',
  'sd.transition.exported': '{count} Jahre exportiert',
  'sd.transition.exportFailed': 'Der Übergangsbericht konnte nicht exportiert werden.',
  'sd.transition.title': 'Abstimmung und Übergangsbericht',
  'sd.transition.years': 'Jahre',
  'sd.transition.openingLines': 'AB-Zeilen',
  'sd.transition.historyLines': 'Verlaufszeilen',
  'sd.transition.warnings': 'Kontrollwarnungen',
  'sd.transition.control': 'Übergangskontrolle',
  'sd.transition.controlHelp': 'Der Bericht stellt importierte Eröffnungsbilanz, Nebenbücher, Bank und Hauptbuchverlauf pro Jahr zusammen. Die Zahlen sind eine Kontrollgrundlage und werden nicht automatisch gebucht.',
  'sd.transition.latestSubledger': 'Ein importierter Nebenbuchsaldo ohne eigenes Jahr wird bei {year} als zuletzt importiertes Nebenbuch angezeigt.',
  'sd.transition.rowSummary': '{opening} AB-Zeilen · {accounts} historische Kontosalden · {history} Verlaufszeilen · Bank-AB {bank}',
  'sd.transition.warningCount': 'Warnungen: {count}',
  'sd.transition.discrepancy': 'Abweichung {amount}',
  'sd.transition.historicalBalance': 'Historischer Saldo',
  'sd.transition.balanceSequence': 'AB / Veränderung / EB',
  'sd.transition.historicalResult': 'Historisches Ergebnis',
  'sd.transition.incomeCost': 'Ertrag {income} · Aufwand {cost}',
  'sd.transition.itemsDeviation': '{count} Posten · Abweichung {amount}',
  'sd.transition.supplierSubledger': 'Kreditoren',
  'sd.transition.ledgerArchive': 'Hauptbucharchiv',
  'sd.transition.empty': 'Noch keine importierten Übergangszahlen vorhanden.',
  'sd.vatTax.exported': '{count} Zeilen exportiert',
  'sd.vatTax.exportFailed': 'Der MwSt.-/Steuerverlauf konnte nicht exportiert werden.',
  'sd.vatTax.title': 'MwSt. und Steuern aus dem Importverlauf',
  'sd.vatTax.periods': 'MwSt.-Zeiträume',
  'sd.vatTax.netVat': 'Netto-MwSt.',
  'sd.vatTax.resultBeforeTax': 'Ergebnis vor Steuern',
  'sd.vatTax.basis': 'Historische Kontrollgrundlage',
  'sd.vatTax.basisHelp': 'Die MwSt. wird pro Zeitraum aus importierten 270x/271x-Konten summiert. SAF-T-MwSt.-Codes werden als Codegrundlage angezeigt, sofern die Exportdatei sie enthält. Dadurch werden keine neuen MVA-meldinger, Belege oder Steuerbuchungen erstellt.',
  'sd.vatTax.yearSummary': '{count} Zeiträume · Ergebnis vor Steuern {amount}',
  'sd.vatTax.archive': 'Archiv',
  'sd.vatTax.period': 'Zeitraum {number} · {label}',
  'sd.vatTax.outputInput': 'Ausg. {output} · Eing. {input}',
  'sd.vatTax.empty': 'Noch kein importierter MwSt.-/Steuerverlauf vorhanden.',
  'sd.vatTax.codes': 'SAF-T-MwSt.-Codes',
  'sd.vatTax.showing': '{shown} von {total} werden angezeigt',
  'sd.vatTax.code': '{year}-{month} Code {code}',
  'sd.vatTax.baseVat': 'Bemessungsgrundlage {base} · MwSt. {vat} · {rate}%',
  'sd.resetMessage': 'Dadurch werden alle Buchhaltungs- und Betriebsdaten des gewählten Unternehmens dauerhaft gelöscht: Rechnungen, Belege, Zahlungen, Kunden, Lieferanten, Produkte, Lohn, Bankdaten, Eröffnungsbilanz, Importarchive, Dateien und alle Nummernkreise. Diese Aktion kann nicht rückgängig gemacht werden. Erstelle zuerst einen vollständigen Export, falls etwas aufbewahrt werden soll.',
  'sd.resetPreserved': 'Das Unternehmensprofil selbst, Mitglieder, Abonnement und Integrationsverbindungen bleiben erhalten. Verwende „Unternehmen löschen“, wenn auch diese entfernt werden sollen.',
  'sd.resetPhrase': 'BESTÄTIGEN',
  'sd.resetTypeLabel': 'Gib {phrase} ein, um das Zurücksetzen zu aktivieren',
  'sd.resetTypeHint': 'Die Schaltfläche bleibt deaktiviert, bis der Text exakt übereinstimmt.',
  'sd.resetConfirm': 'Alles löschen und zurücksetzen',
  'sd.resetComplete': 'Alle Buchhaltungs- und Betriebsdaten wurden gelöscht. Das Unternehmen wurde zurückgesetzt.',
  'sd.resetFailed': 'Das Zurücksetzen konnte nicht abgeschlossen werden.',
  'sd.deleteBusinessMessage': 'Löschung des gewählten Unternehmens in 30 Tagen planen? Das Unternehmen, die Daten und der Zugang werden nach der Karenzzeit entfernt. Du kannst die Löschung vor Ablauf der Frist abbrechen.',
  'sd.deleteBusinessConfirm': 'Löschung planen',
  'sd.customersTitle': 'Import / Export von Kunden',
  'sd.suppliersTitle': 'Import / Export von Lieferanten',
  'sd.productsTitle': 'Import / Export von Produkten',
  'sd.invoicesTitle': 'Import / Export von Rechnungen',
  'sd.vouchersTitle': 'Import / Export von Belegen',
  'sd.supportedFormats': 'Unterstützte Importformate: .xlsx und .csv.',
  'sd.productsHelp': 'Importiere und exportiere Produkte mit Vorlagenspalten. Unterstützte Importformate: .xlsx und .csv.',
  'sd.invoicesHelp': 'Exportiere Rechnungen als CSV oder importiere neue Rechnungen mit einer Vorlage.',
  'sd.vouchersHelp': 'Exportiere die Belegübersicht oder Buchungszeilen. Ein Import wird sicher als vollständiges Exportpaket analysiert.',
  'sd.importInvoices': 'Rechnungen importieren',
  'sd.buildingExport': 'Exportpaket wird erstellt...',
  'sd.exportAll': 'Alles exportieren (.zip)',
  'sd.technicalJson': 'Technisches JSON',
  'sd.analyzing': 'Wird analysiert...',
  'sd.importOtherSystem': 'Aus anderem System importieren',
  'sd.reviewOpenItems': 'Offene Posten prüfen',
  'sd.documentArchive': 'Dokumentarchiv',
  'sd.ledgerArchive': 'Hauptbucharchiv',
  'sd.transitionReport': 'Übergangsbericht',
  'sd.vatTaxHistory': 'MwSt.-/Steuerverlauf',
  'sd.latestAnalysis': 'Letzte Analyse: {files} Dateien, {saft} SAF-T, {excel} Excel, {vouchers} Belegdateien. Status: {status}.',
  'sd.analyzed': 'analysiert',
  'sd.reanalyze': 'Dieselbe Datei erneut analysieren',
  'sd.reread': 'Importdatei erneut einlesen',
  'sd.rereadHelp': 'Die letzte Importdatei ist gespeichert, aber die Analyse ist nicht abgeschlossen oder fehlgeschlagen.',
  'sd.importProposal': 'Vorschlag: {accounts} Saldenkonten, {customers} Kunden, {suppliers} Lieferanten, {products} Produkte, {customerInvoices} offene Kundenrechnungen, {supplierInvoices} offene Lieferantenrechnungen, {balances} Eröffnungssalden, {documents}, {ledger}.',
  'sd.countShown': '{shown}+ {label} ({shown} von {total} angezeigt)',
  'sd.label.archiveDocuments': 'Archivdokumente',
  'sd.label.historyLines': 'Verlaufszeilen',
  'sd.saftTitle': 'SAF-T-Export',
  'sd.saftHelp': 'Exportiere SAF-T Financial XML (Beta) oder importiere Kontenplan, Geschäftspartner und Eröffnungsbilanz aus SAF-T XML.',
  'sd.importSaft': 'SAF-T importieren (MVP)',
});
